import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { NavigationLinkPresentation } from './NavigationLinkPresentation.js';

var NavigationLinkWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(NavigationLinkWrapper, _React$Component);

  var _super = _createSuper(NavigationLinkWrapper);

  function NavigationLinkWrapper(props) {
    var _this;

    _classCallCheck(this, NavigationLinkWrapper);

    _this = _super.call(this, props);
    _this.state = {
      hasKeyboardFocus: false,
      hasMouseHover: false
    };
    return _this;
  }

  _createClass(NavigationLinkWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          hasKeyboardFocus = _this$state.hasKeyboardFocus,
          hasMouseHover = _this$state.hasMouseHover;
      return /*#__PURE__*/React.createElement(NavigationLinkPresentation, Object.assign({}, this.props, {
        hasKeyboardFocus: hasKeyboardFocus,
        onKeyboardFocusChange: function onKeyboardFocusChange(newFocus) {
          return _this2.setState({
            hasKeyboardFocus: newFocus
          });
        },
        hasMouseHover: hasMouseHover,
        onMouseHoverChange: function onMouseHoverChange(newHover) {
          return _this2.setState({
            hasMouseHover: newHover
          });
        },
        onClick: !this.props.disabled ? this.props.onClick : function () {
          /*empty*/
        }
      }), this.props.children);
    }
  }]);

  return NavigationLinkWrapper;
}(React.Component);

export { NavigationLinkWrapper };
